import styled from 'styled-components'
import {
  Input,
  TextArea
} from 'components/common'
import { WidgetComponent } from 'components/pages/common'

export const InputStyled = styled(Input)``

export const WidgetComponentStyled = styled(WidgetComponent)`
  
`

export const TextAreaStyled = styled(TextArea)`

`

export const Buttons = styled.div`
  display: flex;
  gap: 10px;
`